{
  "version": 1,
  "asset_id": "f98bba8b-8e7f-42a4-b0b2-b359ef691a1e",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/f98bba8b-8e7f-42a4-b0b2-b359ef691a1e/hernando-galvalume-metal-roof-destination-roofing-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/f98bba8b-8e7f-42a4-b0b2-b359ef691a1e/hernando-galvalume-metal-roof-destination-roofing-1200w.avif",
  "original_filename": "hernando-galvalume-metal-roof-destination-roofing-1200w.avif",
  "size": 93646,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
